module.exports = __webpack_public_path__ + "img/115052.30a9ba40.png";